import React from 'react';

import styles from './HelperText.module.scss';

const HelperText = ({ children }) => (
  <span className={styles.helperText}>{children}</span>
);
export default HelperText;
